import { useEffect } from 'react'
import { useAuth } from '../auth/AuthContext'
import { syncPendingRecordings } from '../lib/recordingUploader'

/**
 * 保留中のオフライン録音を自動アップロードする常駐コンポーネント。
 * - アプリ起動時（ログイン済み & オンライン）
 * - オンライン復帰時（window 'online' イベント）
 */
export function OfflineRecordingSync() {
  const { user, firebaseUser } = useAuth()

  useEffect(() => {
    if (!firebaseUser || !user?.orgId) return
    const ctx = { firebaseUser, orgId: user.orgId }

    if (navigator.onLine) {
      syncPendingRecordings(ctx).catch(err => console.error('Offline recording sync failed:', err))
    }

    const onOnline = () => {
      syncPendingRecordings(ctx).catch(err => console.error('Offline recording sync failed:', err))
    }
    window.addEventListener('online', onOnline)
    return () => window.removeEventListener('online', onOnline)
  }, [firebaseUser, user?.orgId])

  return null
}
